<script>
    import BlogSummary from '../components/BlogSummary.svelte';
    export let short = false;
    export let blogUrl = "muscle_up_renkaissa";
    let title = "Muscle up renkaissa";
    let author = "Petteri";
    let blogDate = "28.8.2018";
    let titlePic = "2018/muscleup_strip.jpg";
    let firstPara = "Muscle up, jota myös voimavedoksi sanotaan, on liike jossa urheilija punnertaa itsensä roikkumisasennosta renkaiden päälle rengaspitoon. Tässä artikkelissa käymme läpi muutamia vinkkejä liikkeen opettelemiseksi.";
</script>
<!--  Blogi koostuu kahdesta osasta. Eka osa "short" on siis muille siuville tuleva lyhennelmä, jossa on artikkelikuva ja lyhyt teksti -->

{#if short}
<BlogSummary blogPath={blogUrl} title={title} titlePic={titlePic} blogDate={blogDate} firstPara={firstPara}></BlogSummary>

{:else}
    <div class="blog page">
        <article class="container">
            <h1>{title}</h1>
            <div class="blogDate">{author} | {blogDate}</div>
           <div class="blogMainImage" style="background-image: url('/svelte-site/img/blog/{titlePic}')"></div>

           {firstPara}



                <h2>Muscle up - ylävartalon kuningasliike</h2>


                <p>Muscle up ei ole aloittelijoiden liike. Suoritus vaatii melko paljon voimaa ylävartaloon. Jokseenkin repivänä liikkeenä muscle up haastaa myös olkapään liikeradat ja pienet kiertäjälihakset.
                    Perusedellytyksenä voisi sanoa, että sinun tulisi saada useampia leuanvetoja ja dippejä tehtyä kehonpainolla, sekä olkaniveliesi tulisi olla kivuttomat, jotta liikkeen harjoitteluun kannattaa tosissaan ryhtyä. 
                </p>
                    
                <p>Liike haastaa ylävartalon veto- ja työntölihasten lisäksi myös koordinaatiota ja ketteryyttä. Koko kropan täytyy toimia yhtenä yksikkönä. Mikäli orkesteri ei soita yhteen säveleen, ylös ei pääse ja pahimmassa 
                    tapauksessa voi nyrjäyttää olkapäänsä pahasti epävireeseen.</p>

                    <p>Voimistelijoiden keskuudessa liike on lähinnä tarkoitettu renkaisiin kiipeämiseen, perusjuttuja siis, mutta meille peruskuntoilijoille liike antaa sopivasti haastetta opetella jotain uutta. Se on siis täysin opeteltavissa.</p>

                <iframe width="791" height="445" src="https://www.youtube.com/embed/rlKPzQmydlo" title="Muscleup renkaissa" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
                <p class="kuvateksti">Videokooste artikkelissa mainituista liikkeistä</p>




                <h2>Vaatimukset liikkeeseen</h2>

                <p>Muscle up -liikkeen voidaan yksinkertaistettuna sanoa koostuvan kolmesta osasta: Leuanveto rintaan, transitio leuanvedosta dippiasentoon, sekä dippi suorille käsille. Näitä kaikkia kolmea liikettä voi ja kannattaa treenata erillisinä osina. Erikseen treenaamisesta saadaan myös se hyöty, että voiman kasvaessa samalla myös nivelkudokset vahvistuvat. Kun liikkeet sujuvat, voimantuotto on kohdallaan ja nivelet kestävät, voidaan ne yhdistää kokonaiseksi liikkeeksi - muscle upiksi.</p>




                <h3>Ote renkaista - false grip</h3>

                <p>Ensimmäisenä tarvitset oikeanlaisen otteen. Tähän tarkoitukseen kannattaa harjoitella ote nimeltä "false grip". 
                False grip -otteessa koko kehon paino laitetaan ranteen tyveen. Tällä saadaan parikin etua.</p>

                <img src="/svelte-site/img/blog/2018/falsegrip.jpg" alt="False grip" />
                <p class="kuvateksti">False grip</p>

                <p>1. Leuanvetoon tarvittava matka lyhenee. <br>
                Tämä on yllättävänkin merkittävä asia varsinkin mikäli leuanveto rintaan ei ole vahvuutesi. Jokainen sentti on tärkeä.</p>

                <p>2. Käännettäessä keho renkaiden päälle on ranne valmiina dippiin.<br>
                Voit kokeilla tätä itse laittamalla kämmenesi pöydän reunalle niin että ranne menee juuri reunan yli ja kyynärvarsi osoittaa lattiaa kohti. Käännä sitten kyynärvarsi kattoa kohti liikuttamatta kämmentä pöydällä. 
                Huomaa että voit painaa kädelläsi pöytää vasten melko kovaa ilman että liikkeen aikana tulee heikkoa kohtaa. Tästä liikkeestä on kyse; paino on vahvasti ranteen tyvessä.</p>

                <p>Katso videolta miten voit mobilisoida ranteitasi helpomman false gripin saamiseksi. Saman mobilisoinnin voi tehdä sormet käännettynä ulospäin. 
                Kannattaa myös tsekata artikkelimme <a href="/blog/ranteiden_huolto">ranteiden huollosta</a>.</p>

                <p>Toki muscle upin voi tehdä myös ilman false grip otetta, mutta tämä vaatii hitusen enemmän voimaa ja nopeutta. Voimaa voidaan kompensoida kippaamalla, 
                joka tarkoittaa sitä että luodaan keskivartalon lihaksia käyttämällä heijari, jonka voimasta päästään leuanvedossa ylemmäksi. Tätä liikettä kannattaa harjoitella varovasti,
                enkä suosittele sen harjoittelua ennenkuin leuanveto omalla kehonpainolla sujuu jo todella helposti.</p>




                <h3>Perusteet kuntoon</h3>

                <p>Muscle up helpottuu huomattavasti, mikäli saa tehtyä leuanvedon räjähtävästi rintaan asti sekä dipin renkaissa hervottoman syvästä dippiasennosta. Minimivaatimuksena on, että leuanvedon yläasennossa renkaat saisi vedettyä rintakehän tasalle. Tästä sukelletaan renkaiden lävitse syvään dippiasentoon. Mikäli leuanveto jää vajaaksi ei dippiasentoon päästäkään sormia napsauttamalla. Tällöin edessä on yleensä hiusverisuonet poksauttava vääntö ja hivutustaistelu dippiasennon hakemiseksi. Tässä vaiheessa olkapäiden kiertäjälihakset haluavat jo lähteä suihkun kautta kotiin. Kun dippiasentoon on päästy on jäljellä käsivarsien ojentaminen ylös rengaspitoon.</p>
                
                <p>Leuanvedossa kannattaa suosia räjähtäviä toistoja ja saamaan veto mahdollisimman ylös rintaan, jotta siirtyminen dippiin onnistuu. Muscle upin ala-asento lähtee täysin suorilta käsiltä, joten myös leuanvetoa kannattaa treenata suorilta käsiltä. Lisämausteen ala-asennon pitoon saa kiertämällä renkaita ulospäin. Tämä niin sanottu "eagle hold" asento suoristaa kädet melkoisen tehokkaasti.</p>
                
                <p>Dipit renkaissa ovat haastavampia kuin telineessä tehtynä. Renkailla dipatessa kannattaa samalla viedä käsivarret ulkokiertoon kääntämällä kämmenet eteenpäin yläasennon pidossa. Tämä osoittaa hallittua muscleupin yläasentoa.</p>


                <h3>Transitio - painopisteen vieminen renkaiden päälle</h3>
                
                <p>Liikeen vaikein osuus on transitio. Transitiolla tarkoitetaan vaihetta, jossa sukelletaan renkaiden väliin samalla kun siirrytään leuanvedosta dippiasentoon. Mitä nopeampi liike on, sitä vähemmän aikaa kehoa tarvitsee kannatella epäsuotuisassa asennossa. Kovat jätkät saavat tehtyä transition kuin hidastetussa filmissä, mutta tämä vaatiikin jo teräksisen lujat olkapäät.</p>

                <p>Itse transitiota eli kääntöä renkaiden päälle kannattaa aluksi harjoitella jalat maassa. Asetu renkaiden alle seisomaan, ota hyvä ote renkaista ja päästä käsivartesi suoraksi. Tämän jälkeen vedä renkaat kohti rintakehää ja käännä itsesi nopeasti dippiasentoon. Pidä renkaat lähellä kroppaa koko ajan. Tätä liikettä kannattaa alussa jauhaa pitkään. Voit esimerkiksi tehdä liikettä 3-5 x 30 sekunnin työsarjoina tai vaikkapa tabatana (20 sekuntia transitiota ja 10 sekuntia taukoa 8 kierroksen verran).</p>
                

                <h3>Tekniikan harjoittelu liikettä keventämällä</h3>
                
                <p>Muscle up liikkeen tekniikkaa kannattaa hioa keventämällä liikettä joko jalat takana boksilla tai kuminauhan avulla. Myös kaveri voi auttaa jaloista. Suorita liike niin puhtaasti kuin mahdollista, aina vähemmän auttaen. Videolta voit nähdä yhden tavan miten kuminauhaa voi käyttää liikkeessä hyväksi. Kuminauha viritetään renkaiden väliin ja istutaan reilusti päälle. Kannattaa minimoida kiikkuminen ja heilua vähemmän kun videossa mallia näyttävä karvanaama.</p>

                <img class="wp-image-1425 size-medium" src="/svelte-site/img/blog/2018/muscle_up_boksilla.jpg" alt="Muscle up laatikon päältä" width="800" height="492" /> 
                <p class="kuvateksti">Muscle up laatikon päältä</p>
                
                <p>Alussa voit myös tehdä muscle upin negatiivisena. Nouse penkkiä käyttäen rengaspitoon, laskeudu siitä hitaasti syvään dippiasentoon ja edelleen mahdollisimman hitaasti roikkumaan renkaista. Negatiivisia ei kannata kuitenkaan aloittaa ennenkuin leuanvedot ja dipit ovat tuttu juttu. Tämä siksi, että kiertäjälihakset osaavat jo hieman ottaa treenistä tulevaa rasitusta vastaan.</p>


                <h3>Koko liike renkaissa roikkuen</h3>

                <p>Jos false grip pysyy, leuanveto rintaan sujuu ja syvässä dippiasennossa olet kuin kotonasi, on aika siirtyä kokeilemaan muscle upia kokonaisena liikkeenä.</p>

                <p>Voit leuanvedon alussa heijata jaloista reilummin vauhtia ja pyrkiä keventämään kehon painoa nostamalla jalkoja ylöspäin vedon aikana, näin keho on keveimmillään leuanvedon yläasennossa. Nyt kun keho on keveimmillään, käännät nopeasti renkaat lähellä kroppaa pitäen itsesi syvään dippiasentoon. Sinun täytyy siis "syöksyä" renkaiden lävitse. Käännä siis jalat ja katse nopeasti maahan. Mikäli transitio onnistuu, olet lopulta todella syvässä dippiasennossa. Punnerra itsesi vielä ylös ja muscle up on suoritettu!</p>

                <p>Edistyttyäsi liikkeessä ei ole mitenkään mahdotonta tehdä sitä lisäpainojen avulla. Kiviä ei kuitenkaan kannata laittaa taskuun ennen kuin liike on hyvin hallussa. Liian usein liian aikaisin voi johtaa olkapään revähdysvammoihin ja pidempiaikaiseen toipumiseen.</p>

                <p>Ei kannata sortua epätoivoon mikäli muscle up ei onnistu pariin ensimmäiseen kuukauteen tai jopa vuoteen. Liike on monipuolinen ja oppiminen yleensä vaatii lukuisia toistoja ja treenikertoja, mutta onnistuminen on sitäkin palkitsevampaa.</p>

                <p>Tsemppiä treeneihin!</p>

                <p>--Petteri</p>
                
                
                
                
                            
                </article>



                <section class="container">
                    <h2>Lue seuraavaksi</h2>
                    <div class="row">
                        <article class="blog col-xs-12 col-md-4">
                            <BlogSummary blogPath='ranteiden_huolto' title='Ranteiden liikkuvuus ja huolto' titlePic='ranne.jpg' blogDate='' firstPara='Ärtyneet ja kipeät ranteet vaivaavat nykyisin yhä useampaa ihmistä. Vaiva on yleistynyt samalla kun työnkuva on muuttunut enemmän paikallaan nöpöttämiseksi hiiren tai muun laitteen parissa. Lue tästä, mitä voit itse tehdä ranteidesi hyväksi.'></BlogSummary>
                        </article>
                        <article class="blog col-xs-12 col-md-4">
                            <BlogSummary blogPath='2022-09-11_otevoima' title='Otteen ja puristusvoiman vahvistaminen' titlePic='2022/FatGripzMave2.jpg' blogDate='' firstPara='Hyvästä puristusvoimasta on hyötyä niin kuntosalilla kuin kotitöissä. Lue tästä vinkit otevoiman kehittämiseen.'></BlogSummary>
                        </article>
                        <article class="blog col-xs-12 col-md-4">
                            <BlogSummary blogPath='stressitomasti-tuloksiin' title='Stressittömästi tuloksiin' titlePic='riippumatto.jpg' blogDate='' firstPara='Meillä kaikilla on jokin syy motivaattorina, minkä vuoksi treenaamme - jos ja kun treenaamme. Jos haluat näkyviä tuloksia, tai vaikka treenaisit vain omaksi iloksesi tai puolisosi käskystä, kannattaa tämä lukea.'></BlogSummary>
                        </article>
                    </div>
                </section>


</div>
    

{/if}

<style>


</style>
